module.exports = __webpack_public_path__ + "img/P2-B9.bc696628.svg";